import { StorefrontClient } from '@jbhi-fi/apis/src/storefront';
import Cookies from 'js-cookie';
import { transformStorefrontCartToJbCart } from '../../utils/cart/transformStorefrontCartToJbCart';
import { JbCart } from '@jbhi-fi/apis/src/shopify/types/JbCart';

export class ShopifyStorefrontClient extends StorefrontClient<JbCart> {
  constructor() {
    super({
      storeDomain: process.env.SLATE_STORE ?? 'NOT_CONFIGURED',
      storefrontApiKey: process.env.STOREFRONT_API_KEY ?? 'NOT_CONFIGURED',
      apiVersion: process.env.STOREFRONT_API_VERSION,
      getCartId: () => Cookies.get('cart'),
      refreshCart: ShopifyStorefrontClient.refreshCart,
      cartTransformer: transformStorefrontCartToJbCart,
    });
  }

  /**
   * This function is used to refresh the cart with a new cookie (needed to update the buyer identity for perks)
   * @returns a new cart id
   */
  static refreshCart = async (): Promise<string> => {
    const response = await fetch('/cart/update.js');
    const cartId = (await response.json()).token;
    return cartId;
  };
}
